import api from './api';
import { TaskFieldDefinitionDto } from '../types/django';

export const taskFieldService = {
async getAll(workflowId?: number) {
  const response = await api.get(
    '/task-field-definitions/',
    {
      params: workflowId ? { workflow: workflowId } : {}
    }
  );

  return response.data.results;
},

  async create(data: Partial<TaskFieldDefinitionDto>) {
      console.log("➡️ POST TASK FIELD:", data);
    const response = await api.post('/task-field-definitions/', data);
    return response.data;
  },

  async update(id: number, data: Partial<TaskFieldDefinitionDto>) {
    const response = await api.patch(`/task-field-definitions/${id}/`, data);
    return response.data;
  },

  async delete(id: number) {
    await api.delete(`/task-field-definitions/${id}/`);
  },
};